import React from "react";
import { useTranslation } from "react-i18next";
export default function useResponsiveLanguage() {
  const { i18n, t } = useTranslation();
  function responsivelanguage(arabic: any, english: any): any {
    if (i18n.language === "ar") {
      return arabic;
    } else {
      return english;
    }
  }
  return { responsivelanguage, t, i18n };
}
